import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const UrshilaMehta = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Urshila Mehta"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Urshila-2.jpg"
                bio="Urshila Mehta serves as Art & Culture Liaison for The JSW Foundation and Mrs Sangita Jindal. An art and culture professional with over a decade of varied experience across arts administration and management – she has worked with a number of international museums, art galleries, auction houses, art consultants, curators and cultural institutions across Italy, the USA and India."
            />
        </>
    );
};

export default UrshilaMehta;